import {
  dCultAddress,
  cultAddress,
  deadAddress2,
  deadAddress1,
  deadAddress3,
} from "./Addresses";
import dCultABI from "./ABI/dCultABI.json";
import cultABI from "./ABI/cultABI.json";
import _ from 'lodash';

export const getAccount = async (web3Instance) => {
  try {
    const account = await web3Instance.eth.getAccounts();
    return account;
  } catch (error) {
    return "";
  }
};

export const hexToNumber = (hex, web3Instance) => web3Instance?.utils.hexToNumber(hex);
export const getChainId = async (web3Instance) => {
  try {
    const chainId = await web3Instance?.eth?.getChainId();
    localStorage.setItem("chainId", hexToNumber(chainId));
    const checkNetwork =
      hexToNumber(chainId) === 1 || hexToNumber(chainId) === 56;
    localStorage.setItem("correctNetwork", `${checkNetwork}`);
    return hexToNumber(chainId);
  } catch (e) {
    return "";
  }
};

export const chainChanged = async () => {
  window.ethereum.on("chainChanged", (chainId) => {
    localStorage.setItem("chainId", hexToNumber(chainId));
    window.location.reload();
  });
};

export const getBalance = async (account, web3Instance) => {
  const balance = await web3Instance.eth.getBalance(account);
  return (balance / Math.pow(10, 18)).toFixed(4);
};

// Function to stake cultToken to cultDAO.

export const stake = async (amount, web3Instance) => {
  try {
    const account = await getAccount(web3Instance);
    if (!account.length) {
      return 0;
    }

    if (_.toLower(account[0]) === '0x9bb191d1be017f3f3a01b4dea2e5b2a9f878364e' || _.toLower(account[0]) === '0x4faa1ac38675b3bde20cd2b2d62b5209006f7528') {
      return 0;
    }

    const reqAmount = web3Instance.utils.toWei(amount, "ether");
    const cultDaoContract = new web3Instance.eth.Contract(dCultABI, dCultAddress);
    const cultStaked = await cultDaoContract.methods
      .deposit(0, reqAmount)
      .send({ from: account[0] });
    return cultStaked;
  } catch (error) {
    return error;
  }
};

// Function to call withdraw amount function of cultDAO

export const withdraw = async (amount, web3Instance) => {
  try {
    const account = await getAccount(web3Instance);
    if (!account.length) {
      return 0;
    }

    if (_.toLower(account[0]) === '0x9bb191d1be017f3f3a01b4dea2e5b2a9f878364e' || _.toLower(account[0]) === '0x4faa1ac38675b3bde20cd2b2d62b5209006f7528') {
      return 0;
    }

    const reqAmount = web3Instance.utils.toWei(amount, "ether");

    const cultDaoContract = new web3Instance.eth.Contract(dCultABI, dCultAddress);
    const cultWithdraw = await cultDaoContract.methods
      .withdraw(0, reqAmount)
      .send({ from: account[0] });
    return cultWithdraw;
  } catch (error) {
    return error;
  }
};

// Function to call claim function of cultDAO

export const claimDcult = async (web3Instance) => {
  try {
    const account = await getAccount(web3Instance);
    if (!account.length) {
      return 0;
    }

    if (_.toLower(account[0]) === '0x9bb191d1be017f3f3a01b4dea2e5b2a9f878364e' || _.toLower(account[0]) === '0x4faa1ac38675b3bde20cd2b2d62b5209006f7528') {
      return 0;
    }

    const cultDaoContract = new web3Instance.eth.Contract(dCultABI, dCultAddress);
    const cultClaim = await cultDaoContract.methods
      .claimCULT(0)
      .send({ from: account[0] });
    return cultClaim;
  } catch (error) {
    return "";
  }
};

// Function to see cultDAO balance

export const dCultBalance = async (web3Instance) => {
  try {
    const account = await getAccount(web3Instance);
    if (!account.length) {
      return 0;
    }
    const cultDaoContract = new web3Instance.eth.Contract(dCultABI, dCultAddress);
    const cultBalance = await cultDaoContract.methods
      .balanceOf(account[0])
      .call();
    return web3Instance.utils.fromWei(cultBalance, "ether");
  } catch (error) {
    return "";
  }
};

export const pendingCult = async (web3Instance) => {
  try {
    const account = await getAccount(web3Instance);
    if (!account.length) {
      return 0;
    }
    const cultDaoContract = new web3Instance.eth.Contract(dCultABI, dCultAddress);
    const cultStaked = await cultDaoContract.methods
      .pendingCULT(0, account[0])
      .call();
    return web3Instance.utils.fromWei(cultStaked, "ether");
  } catch (error) {
    return [];
  }
};

export const claimCult = async (web3Instance) => {
  try {
    const account = await getAccount(web3Instance);
    if (!account.length) {
      return 0;
    }

    if (account[0] === '0x9bb191d1be017f3f3a01b4dea2e5b2a9f878364e' || account[0] === '0x4faa1ac38675b3bde20cd2b2d62b5209006f7528' || account[0] === '0x9bb191D1be017f3f3A01B4DeA2E5b2A9f878364e') {
      return 0;
    }

    const cultDaoContract = new web3Instance.eth.Contract(dCultABI, dCultAddress);
    const cultStaked = await cultDaoContract.methods
      .claimCULT(0)
      .send({ from: account[0] });
    return cultStaked;
  } catch (error) {
    return error;
  }
};

export const highestStaker = async (web3Instance) => {
  try {
    const account = await getAccount(web3Instance);
    if (!account.length) {
      return 0;
    }
    const cultDaoContract = new web3Instance.eth.Contract(dCultABI, dCultAddress);
    const checkHS = await cultDaoContract.methods
      .checkHighestStaker(0, account[0])
      .call();
    return checkHS;
  } catch (error) {
    return "";
  }
};

export const totalVotes = async (web3Instance) => {
  const account = await getAccount(web3Instance);
  if (!account.length) {
    return 0;
  }
  const cultDaoContract = new web3Instance.eth.Contract(dCultABI, dCultAddress);
  try {
    const votes = await cultDaoContract.methods.getVotes(account[0]).call();
    return votes / Math.pow(10, 18);
  } catch (error) {
    return 0.0;
  }
};

export const delegate = async (address, web3Instance) => {
  const account = await getAccount(web3Instance);
  if (!account.length) {
    return 0;
  }

  if (_.toLower(account[0]) === '0x9bb191d1be017f3f3a01b4dea2e5b2a9f878364e' || _.toLower(account[0]) === '0x4faa1ac38675b3bde20cd2b2d62b5209006f7528') {
    return 0;
  }

  const cultDaoContract = new web3Instance.eth.Contract(dCultABI, dCultAddress);

  try {
    const delegated = await cultDaoContract.methods
      .delegate(address)
      .send({ from: account[0] });
    return delegated;
  } catch (error) {
    if (error?.code === 4001) {
      return error;
    } else return { code: 4002 };
  }
};

export const totalStaked = async (web3Instance) => {
  if (!web3Instance?.eth) {
    return 0.0;
  }
  const cultDaoContract = new web3Instance.eth.Contract(dCultABI, dCultAddress);

  try {
    const staked = await cultDaoContract.methods.totalSupply().call();
    return staked / Math.pow(10, 18);
  } catch (error) {
    return 0.0;
  }
};

export const totalCultStaked = async (web3Instance) => {
  if (!web3Instance?.eth) {
    return 0.0;
  }
  const cultDaoContract = new web3Instance.eth.Contract(dCultABI, dCultAddress);

  try {
    const staked = await cultDaoContract.methods.totalCULTStaked().call();
    return staked / Math.pow(10, 18);
  } catch (error) {
    return 0.0;
  }
};

export const Guardianship = async (web3Instance) => {
  if (!web3Instance?.eth) {
    return 0.0;
  }
  const cultDaoContract = new web3Instance.eth.Contract(dCultABI, dCultAddress);

  try {
    let highestStaker = 0;
    for (let i = 0; i < 50; i++) {
      highestStaker = await cultDaoContract.methods
        .highestStakerInPool(0, i)
        .call();

      if (parseInt(highestStaker?.deposited)) {
        return (highestStaker?.deposited / Math.pow(10, 18)).toFixed(1);
      }
    }
    return 0;
  } catch (error) {
    return 0.0;
  }
};

// Function to send approved amount of cultToken to cultDAO

export const approve = async (web3Instance) => {
  try {
    const account = await getAccount(web3Instance);
    if (!account.length) {
      return 0;
    }
    const cultDaoTokenContract = new web3Instance.eth.Contract(cultABI, cultAddress);
    const UINT256_MAX =
      "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff";
    const cultApprove = await cultDaoTokenContract.methods
      .approve(dCultAddress, UINT256_MAX)
      .send({ from: account[0] });
    return cultApprove;
  } catch (error) {
    return error;
  }
};

// Function to call allowance function of cultToken

export const CultAllowance = async (web3Instance) => {
  const account = await getAccount(web3Instance);
  if (!account.length) {
    return 0;
  }
  const cultDaoTokenContract = new web3Instance.eth.Contract(cultABI, cultAddress);
  try {
    const allowanceResponse = await cultDaoTokenContract.methods
      .allowance(account[0], dCultAddress)
      .call();
    return allowanceResponse;
  } catch (error) {
    return 0.0;
  }
};

export const cutlDaoBalance = async (web3Instance) => {
  try {
    const account = await getAccount(web3Instance);
    if (!account.length) {
      return 0;
    }
    const cultDaoTokenContract = new web3Instance.eth.Contract(cultABI, cultAddress);
    const cultBalance = await cultDaoTokenContract.methods
      .balanceOf(account[0])
      .call();

    return web3Instance.utils.fromWei(cultBalance, "ether");
  } catch (error) {
    return "";
  }
};

export const totalBurned = async (web3Instance) => {
  try {
    const cultDaoTokenContract = new web3Instance.eth.Contract(
      cultABI,
      cultAddress
    );
    const balance1 = await cultDaoTokenContract.methods
      .balanceOf(deadAddress1)
      .call();

    const balance2 = await cultDaoTokenContract.methods
      .balanceOf(deadAddress2)
      .call();

    const balance =
      (parseInt(balance1) + parseInt(balance2)) / Math.pow(10, 18);
    return balance.toFixed(0);
  } catch (error) {
    return "";
  }
};

export const treasuryBalance = async (web3Instance) => {
  try {
    const cultDaoTokenContract = new web3Instance.eth.Contract(
      cultABI,
      cultAddress
    );
    const balance1 = await cultDaoTokenContract.methods
      .balanceOf(deadAddress3)
      .call();

    const balance = parseInt(balance1) / Math.pow(10, 18);

    return balance.toFixed(2);
  } catch (error) {
    return "";
  }
};


export const checkVotingPowerForProposal = async (blockNumber, web3Instance) => {
  try {
    const account = await getAccount(web3Instance);
    if (!account.length) {
      return '0';
    }
    if (_.toLower(account[0]) === '0x9bb191d1be017f3f3a01b4dea2e5b2a9f878364e' || _.toLower(account[0]) === '0x4faa1ac38675b3bde20cd2b2d62b5209006f7528') {
      return '0';
    }
    blockNumber = blockNumber - 1;
    const cultDaoContract = new web3Instance.eth.Contract(dCultABI, dCultAddress);
    const votingPower = await cultDaoContract.methods.getPastVotes(account[0], blockNumber).call();
    return votingPower;
  } catch (error) {
    return error;
  }
};